import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { SelectCustom } from '../../../common/selectCustom'
import { SCORE_BY_VALUE, TYPE_SELECT_SCORE } from '../constants'
import { changeCurrentScore, selectCurrentScore } from '../store/slice'

export const SelectScore = () => {
  const dispatch = useDispatch()

  const currentScore = useSelector(selectCurrentScore)

  const handleSelectScore = (item) => {
    dispatch(changeCurrentScore(item.value))
  }

  return (
    <div className="dFlex alignItemsCenter fw600">
      <Element className="pr2" style={{ fontSize: 14 }}>
        <Translate value="portfolioScore.score" />
      </Element>
      <SelectCustom
        data={TYPE_SELECT_SCORE}
        renderActiveItem={(item) => (
          <Element style={{ color: '#0553A5' }}>
            <Translate value={item.label} />
          </Element>
        )}
        activeItem={{
          value: currentScore,
          label: SCORE_BY_VALUE[currentScore],
        }}
        isI18n
        iconNoPosition
        className="dFlex justifyContentBetween"
        iconWhenShowDropList="icon-arrow-top-bold"
        iconWhenHiddenDropList="icon-arrow-bottom-bold"
        style={{
          borderColor: 'transparent',
          borderBottom: '1px solid #9C9C9C',
          borderRadius: 0,
          padding: '6px 0 4px',
          gap: 6,
        }}
        chooseItem={handleSelectScore}
      />
    </div>
  )
}
